export enum CarMovementEnum {
    Stock = 1,
    RequestMovement = 2,
    Movement = 3,
    PendingNF = 4
}